import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { UserService } from './user.service';

export interface HealthDiagnosticField {
  title: string;
  value: number;
  label: string;
  factorySpec?: number | null;
}

export interface HealthDiagnosticData {
  v1: HealthDiagnosticField;
  v2: HealthDiagnosticField;
  v3: HealthDiagnosticField;
  a1: HealthDiagnosticField;
  a2: HealthDiagnosticField;
  a3: HealthDiagnosticField;
  nl: HealthDiagnosticField;
  fl: HealthDiagnosticField;
  board_t: { title: string; value: number; label: string };
  last_err: { title: string; value: string; label: string };
  date: { title: string; value: string; label: string };
}

export interface HealthChecks {
  controllerOutputsOk: boolean;
  buildingVoltageOk: boolean;
  wireSizeOk: boolean;
  allZonesEnergizing: boolean;
  wattageDrop: string;
  maxTempEstimate: string;
  nonEnergizedZones: string;
  lowPowerOutputs: string;
  factorySpecsNotSet?: boolean;
}

export interface HealthElement {
  name: string;
  isHeating: boolean;
  isEnergized: boolean;
  factoryAmperageUnknown?: boolean;
  percentageOfFactory?: number | null;
}

export interface HealthDiagnosticsResponse {
  diagnosticData: HealthDiagnosticData;
  healthChecks: HealthChecks;
  elements: HealthElement[];
}

@Injectable({
  providedIn: 'root'
})
export class HealthDiagnosticsService {
  private baseUrl = environment.claimApi;

  constructor(
    private http: HttpClient,
    private userService: UserService
  ) {}

  getHealthDiagnostics(kilnId: string, mac: string): Observable<HealthDiagnosticsResponse> {
    const url = `${this.baseUrl}/kilns/${kilnId}/health?mac=${mac.toUpperCase()}`;
    
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'x-access-token': this.getAuthToken()
    });

    return this.http.get<HealthDiagnosticsResponse>(url, { headers });
  }

  private getAuthToken(): string {
    const loginData = this.userService.getLoginData();
    return loginData ? loginData.token : '';
  }
} 